import * as api from 'services/api'

const live = {
	state: {
		//id: '',
		/** 详情数据 */
		detail: {},
		/** 直播间数据 */
		comments_lr: [],
		/** 大家聊数据 */
		comments_ac: [],

		maxid_lr: '',
		maxid_ac: '',
		loading_lr: false,
		loading_ac: false,
		hasMore_lr: true,
		hasMore_ac: true,
		next_lr:'',
		next_ac:'',
		params:{
			sysCode:'',
			id:'',
		}
	},
	mutations: {
		'live:update:params'(state,params) {
			state.params.sysCode=params.sysCode;
			
			state.params.id = params.id;
		},
		'live:update:detail'(state, detail) {
			state.detail = detail;
		},
		'live:update:comments_lr'(state,comments){
			let {next_lr,comments_lr}=state;
			if(comments_lr.length==0){
				comments_lr=comments.items;
			}else if(comments.page.next){
				if(comments.items[0].top){
					comments_lr[0]=comments.items.splice(0,1);
				}
				comments_lr.push(...comments.items)
			}else if(!comments.page.next){
				state.comments_lr.push(...comments.items);
				
			}
			state.hasMore_lr=(comments.page && comments.page.next)?true:false;

			state.comments_lr=comments_lr;
			state.loading_lr=false;
			state.next_lr=comments.page.next;
			
		},
		'live:update:comments_ac'(state, comments) {
			if(comments.page && comments.page.next) {
				state.comments_ac.push(...comments.items);	
			}
			else {
				comments.items?state.comments_ac.push(...comments.items):state.comments_ac=state.comments_ac;
				state.hasMore_ac = false;
			}
			state.next_ac= (comments.page && comments.page.next) ||'',
			state.loading_ac = false;
		},
		'live:update:loading_lr'(state, loading) {
			state.loading_lr = loading;
		},
		'live:update:loading_ac'(state, loading){
			state.loading_lr = loading;
		}

	},
	actions: {
		async 'live:init'({commit, dispatch}, params) {
			commit('live:update:params', params);
			// 获取详情数据
			dispatch('live:update:detail');
			// 获取直播间数据
			dispatch('live:update:comments_lr');
			// 获取大家聊数据
			dispatch('live:update:comments_ac');
		},
		async 'live:update:detail'({commit, state}) {
			const res = await api.getLiveDetail({articleId:state.params.id});
			if(res.code === 0) {
				const data=res.item || [];
				commit('live:update:detail', data);
			}
		},
		async 'live:update:comments_lr'({commit, state}) {
			commit('live:update:loading_lr', true);
			const res = await api.getLive({articleId: state.params.id,pageToken:state.next_lr});
			if(res.code >= 0) {
				commit('live:update:comments_lr',res);
			}
		},
		async 'live:update:comments_ac'({commit, state}) {
			commit('live:update:loading_ac', true);
			const res = await api.getLiveComments({articleId: state.params.id,pageToken:state.next_ac});
			if(res.code >= 0) {
				commit('live:update:comments_ac', res);
			}
		}
	},
	getters: {
		'live:detail': state => {
			return state.detail;
		},
		'live:comments_lr': state => {
			return state.comments_lr;
		},
		'live:comments_ac': state => {
			return state.comments_ac;
		},
		'live:loading_lr': state => {
			return state.loading_lr;
		},
		'live:loading_ac': state => {
			return state.loading_ac;
		},
		'live:hasMore_lr': state => {
			return state.hasMore_lr;
		},
		'live:hasMore_ac': state => {
			return state.hasMore_ac;
		}
	}
};

export default live;


// WEBPACK FOOTER //
// ./src/store/modules/live.js